import "./waving-duck.sass";

import { useCallback, useEffect, useRef } from "react";
import gsap from "gsap";

import iDuck from "../../../../assets/icons/hero/pink_duck.webp";
import { MOBILE_WIDTH_PX } from "../../../../const/const";
import { useScrollContext } from "../../../../lib/scroll";

const WavingDuck = () => {
  const scrollContext = useScrollContext();
  const duckRef = useRef<HTMLImageElement>(null);
  const mobileDuckXToRef = useRef<((value: number) => gsap.core.Tween) | null>(
    null,
  );

  const getBaseRight = useCallback(() => {
    if (window.innerWidth >= 2560) {
      return 394.4;
    }

    if (window.innerWidth >= 1920) {
      const progress = (window.innerWidth - 1920) / (2560 - 1920);
      return 295.8 + (394.4 - 295.8) * progress;
    }

    return 250;
  }, []);

  /** Устанавливает новую сдвиг справа для утки. */
  const updateDuckRight = (right: number) => {
    const duck = duckRef.current;
    if (!duck) {
      return;
    }

    duck.style.right = right + "px";
  };

  const updateDuckX = (offsetX: number) => {
    const duck = duckRef.current;
    if (!duck) {
      return;
    }

    if (!mobileDuckXToRef.current) {
      mobileDuckXToRef.current = gsap.quickTo(duck, "x", {
        duration: 0.35,
        ease: "power2.out",
      });
    }

    mobileDuckXToRef.current(offsetX);
  };

  /** Обработчик скролла страницы. */
  const handleScroll = useCallback((amount: number, _delta: number) => {
    if (window.innerWidth <= MOBILE_WIDTH_PX) {
      updateDuckX(amount * 0.35);
      return;
    }

    updateDuckRight(getBaseRight() - amount);
  }, [getBaseRight]);

  useEffect(() => {
    const handleResize = () => {
      const duck = duckRef.current;
      if (!duck) {
        return;
      }

      if (window.innerWidth <= MOBILE_WIDTH_PX) {
        updateDuckX(window.scrollY * 0.35);
        return;
      }

      duck.style.left = "";
      gsap.set(duck, { x: 0 });
      updateDuckRight(getBaseRight());
    };

    handleResize();
    window.addEventListener("resize", handleResize, { passive: true });
    return () => window.removeEventListener("resize", handleResize);
  }, [getBaseRight]);
  useEffect(() => {
    if (!scrollContext) {
      return;
    }

    scrollContext.bindScrollHandler(handleScroll);
    handleScroll(window.scrollY, 0);

    return () => {
      scrollContext.unbindScrollHandler(handleScroll);
    };
  }, [handleScroll, scrollContext]);

  useEffect(() => {
    const mm = gsap.matchMedia();

    mm.add(`(max-width: ${MOBILE_WIDTH_PX}px)`, () => {
      const duck = duckRef.current;
      if (!duck) {
        return;
      }

      const tween = gsap.fromTo(
        duck,
        { y: 10 },
        {
          y: -10,
          duration: 1,
          ease: "sine.inOut",
          repeat: -1,
          yoyo: true,
        },
      );

      return () => {
        tween.kill();
        gsap.set(duck, { clearProps: "transform" });
      };
    });

    return () => {
      mm.revert();
    };
  }, []);

  return (
    <img
      ref={duckRef}
      style={{ right: `${getBaseRight()}px` }}
      src={iDuck}
      className="waving-duck"
      alt=""
    />
  );
};

export default WavingDuck;
